import React from 'react';
import { IIconProps } from '../interfaces';
const AppleIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <defs>
          <path d="m9.413 3.86.246.013c.515.015 1.982.204 2.928 1.585-.076.046-1.747 1.03-1.729 3.05.019 2.173 1.705 3.041 2.072 3.204l.06.025.01.004-.014.051a8.22 8.22 0 0 1-1.1 2.221c-.657.983-1.344 1.944-2.437 1.962-1.06.024-1.418-.626-2.635-.626-1.228 0-1.608.608-2.626.65-1.04.038-1.835-1.05-2.515-2.023C.313 11.987-.745 8.37.674 5.91c.688-1.207 1.942-1.984 3.282-2.004 1.041-.022 2.008.704 2.648.704.628 0 1.823-.868 3.055-.738zM9.672 0c.104.946-.27 1.879-.818 2.564-.571.675-1.485 1.191-2.375 1.125-.117-.91.334-1.879.839-2.47C7.888.55 8.879.035 9.672 0z" id="hb5fgzjxla"/>
        </defs>
        <use fill={props.color} fillRule="nonzero" xlinkHref="#hb5fgzjxla"/>
      </svg>
  )
};

export default AppleIcon;